import api from "../../services/api";
import { types } from "../types/types";
import Constants from "../../services/constants";
import { hideLoaderAction, showLoaderAction } from "./loaderAction";
 
const getReplacements = (setLoading) => async (dispatch) => {
    try {
        if (setLoading) {
            setLoading(true);
        }
 
        const res = await api("get", Constants.END_POINT.REPLACEMENT);
 
        if (res?.success && res?.data) {
            const payload = Array.isArray(res.data) ? res.data : (Array.isArray(res.data.orders) ? res.data.orders : []);
            dispatch({
                type: types.CHANGE_REPLCAMENT,
                payload,
            });
        } else {
            // API call failed or returned no data
            dispatch({
                type: types.CHANGE_REPLCAMENT,
                payload: [],
            });
        }
    } catch (error) {
        console.error("Error fetching replacements:", error);
        dispatch({
            type: types.CHANGE_REPLCAMENT,
            payload: [],
        });
    } finally {
        if (setLoading) {
            setLoading(false);
        }
    }
};
const getReplacement = (id, returnData) => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("get", Constants.END_POINT.REPLACEMENT + id);
    if (res.success) {
        if (res.data) {
            if (returnData) {
                returnData(res.data);
            }
        }
    }
    dispatch(hideLoaderAction());
};
 
export { getReplacements, getReplacement };
 
 